import { SelectField, TextField } from '@mi-front/ui';
import { useFormikContext } from 'formik';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { getGipStationIds } from '../../get-gip-station-ids';
import { useGipCustomFieldsQuery } from '../../hooks/useGipCustomFieldsQuery';
import { GipReportValues } from '../../types';
import { LoadOrderParamsFromCustomField } from './LoadOrderParamsFromCustomField';

/** Custom field key/value filters for the GIP report form. */
export function CustomFields() {
  const { $t } = useIntl();
  const { values } = useFormikContext<GipReportValues>();
  const query = useGipCustomFieldsQuery({
    stations: getGipStationIds(values),
  });

  const options = useMemo(
    () =>
      [...(query.data ?? [])]
        .sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()))
        .map((name) => ({ name })),
    [query.data],
  );

  if (!options.length) {
    return null;
  }

  return (
    <div>
      <div className="row">
        <div className="col-6">
          <SelectField
            name="customFieldKey"
            label={$t({
              id: 'audit.gipReport.form.customField',
              defaultMessage: 'Campo custom',
            })}
            placeholder={$t({
              id: 'audit.gipReport.form.selectCustom',
              defaultMessage: 'Seleccione campo custom',
            })}
            options={options}
            isClearable
            getOptionLabel={(value) => value.name}
            getOptionValue={(value) => value.name}
          />
        </div>
        <div className="col-6">
          <TextField
            name="customFieldValue"
            label={$t({
              id: 'audit.gipReport.form.customFieldValue',
              defaultMessage: 'Valor del campo',
            })}
          />
        </div>
      </div>
      <div style={{ marginTop: '-16px' }}>
        <LoadOrderParamsFromCustomField />
      </div>
    </div>
  );
}
